/* External dependencies */
import { ofType, StateObservable } from 'redux-observable';
import { from, Observable } from 'rxjs';
import { catchError, switchMap, withLatestFrom } from 'rxjs/operators';

/* Local dependencies */
import { confirmForgotPasswordRequest, forgotPasswordRequest } from '../../../../../clients/custom-auth';
import { RootState } from '../../../../../redux/store';
import {
  confirmForgotPasswordFailed,
  ConfirmForgotPasswordRequest,
  confirmForgotPasswordSuccess,
  ForgotPasswordAction,
  ForgotPasswordActionTypes,
  forgotPasswordFailed,
  ForgotPasswordRequest,
  forgotPasswordSuccess,
} from './actions';

export function forgotPasswordEpic(action$: Observable<ForgotPasswordAction>, state$: StateObservable<RootState>) {
  return action$.pipe(
    ofType(ForgotPasswordActionTypes.FORGOT_PASSWORD_REQUEST),
    withLatestFrom(state$),
    switchMap(([action]: [ForgotPasswordRequest, RootState]) => {
      return from(forgotPasswordRequest(action)).pipe(
        switchMap(() => from([forgotPasswordSuccess(action.username)])),
        catchError((error) => from([forgotPasswordFailed(error)])),
      );
    }),
  );
}

export function confirmForgotPasswordEpic(
  action$: Observable<ForgotPasswordAction>,
  state$: StateObservable<RootState>,
) {
  return action$.pipe(
    ofType(ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_REQUEST),
    withLatestFrom(state$),
    switchMap(([action]: [ConfirmForgotPasswordRequest, RootState]) => {
      return from(confirmForgotPasswordRequest(action)).pipe(
        switchMap(() => from([confirmForgotPasswordSuccess()])),
        catchError((error) => from([confirmForgotPasswordFailed(error)])),
      );
    }),
  );
}
